module.exports = __webpack_public_path__ + "static/media/boop_video.f90dcf0d.mov";